import React, { useState } from 'react';
// import Widget from '@nackle/learning-everywhere';
import { Layout, Row, Card } from 'antd';
import { authService } from '../../auth/authService';
import { LanguageSelector } from '../../components/formItems';
import SelectOrTransfer from '../../components/selectOrTransfer/SelectOrTransfer';
import './style.less';
import { NotFoundErrorView } from '../NotFoundErrorView';
import { FeatureFlag } from '../../featureFlags';
import { flags } from '../../featureFlags/flags';


const classStyles = [
    {
        key: 'default',
        label: 'Default',
    },
    {
        key: 'red',
        label: 'Red'
    },
    {
        key: 'large',
        label: 'Large'
    },
    {
        key: 'gray',
        label: 'Gray'
    }
];

const sortOrderOptions = [
    {
        key: 'Ascending',
        label: 'Ascending',
    },
    {
        key: 'Descending',
        label: 'Descending'
    }
];

const sortByOptions = [
    {
        key: 'id',
        label: 'ID',
    },
    {
        key: 'name',
        label: 'Name'
    },
    {
        key: 'createdAt',
        label: 'Created At'
    },
    {
        key: 'ratingAverage',
        label: 'Rating Average'
    }
];

const excludeOptions = [
    {
        key: 'excludeCompleted',
        label: 'Exclude Completed',
    },
    {
        key: 'excludeNone',
        label: 'Exclude None'
    }
];

const paginationEnabledOptions = [
    {
        key: 'true',
        label: 'Enabled',
    },
    {
        key: 'disabled',
        label: 'Disabled'
    }
];


export default function DemoPage( props ) {

    const [ language, setLanguage ] = useState( 'en-US' );
    const [ pageCount, setPageCount ] = useState( 10 );
    const [ classStyle, setClassStyle ] = useState( classStyles[ 0 ].key );
    const [ sortOrder, setSortOrder ] = useState( sortOrderOptions[ 0 ].key );
    const [ sortBy, setSortBy ] = useState( sortByOptions[ 0 ].key );
    const [ exclude, setExclude ] = useState( excludeOptions[ 0 ].key );
    const [ paginationEnabled, setPaginationEnabled ] = useState( paginationEnabledOptions[ 0 ].key );

    return <FeatureFlag name={ flags.DEMO } fallback={ <NotFoundErrorView /> }>
        <Layout className="demo-page">

            <Card title="Configurations">
                <Row>
                    <Card title="Locale">
                        <LanguageSelector
                            value={ language }
                            mode="select-single"
                            onChange={ setLanguage }
                        />
                    </Card>

                    <Card title="Page Size">
                        <SelectOrTransfer
                            value={ pageCount }
                            dataSource={ [ ...Array( 5 ).keys() ].map( n => ( n * 5 ) + 5 ).map( n => ( { key: n, label: n } ) ) }
                            onChange={ setPageCount }
                            mode='select-single'
                        />
                    </Card>

                    <Card title="Style Class">
                        <SelectOrTransfer
                            value={ classStyle }
                            dataSource={ classStyles }
                            onChange={ setClassStyle }
                            mode='select-single'
                        />
                    </Card>
                </Row>
                
                <Row>
                    <Card title="Sort Order">
                        <SelectOrTransfer
                            value={ sortOrder }
                            dataSource={ sortOrderOptions }
                            onChange={ setSortOrder }
                            mode='select-single'
                        />
                    </Card>
                    <Card title="Sort By">
                        <SelectOrTransfer
                            value={ sortBy }
                            dataSource={ sortByOptions }
                            onChange={ setSortBy }
                            mode='select-single'
                        />
                    </Card>

                    <Card title="Exclude">
                        <SelectOrTransfer
                            value={ exclude }
                            dataSource={ excludeOptions }
                            onChange={ setExclude }
                            mode='select-single'
                        />
                    </Card>

                    <Card title="Pagination Enabled">
                        <SelectOrTransfer
                            value={ paginationEnabled }
                            dataSource={ paginationEnabledOptions }
                            onChange={ setPaginationEnabled }
                            mode='select-single'
                        />
                    </Card>
                </Row>
            </Card>

            {/* <Card title="Learning Everywhere Course Widget">
                <Widget
                    classNames={ classStyle }
                    accessToken={ authService.getAccessToken() }
                    environment="qa"
                    locale={ language }
                    pageSize={ pageCount }
                    loadingMsg={ 'Loading Courses...' }
                    orderBy= { sortBy }
                    orderAscending= { sortOrder === 'Ascending' }
                    excludeCompletedCourses= { exclude === 'excludeCompleted' }
                    paginateRequest= { paginationEnabled === 'true' }
                    limit={ pageCount }
                    useSegmentationFilter={ false }
                />
            </Card> */}

        </Layout>
    </FeatureFlag>;
}